import React, { Fragment } from "react";
import AddFlashCard from "../components/FlashCard/AddFlashCard";


const FlashCardPage = () => {
    return (
    <Fragment>
        <AddFlashCard/>
    </Fragment>)
}

export default FlashCardPage;